import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Button, alpha } from '@mui/material';
import { Link } from 'react-router-dom';

const orangeBase = '#ff8400';
const grayBase = '#f2f2f2';

const theme = createTheme({
  palette: {
    primary: {
      main: orangeBase,
      light: alpha(orangeBase, 0.5),
      dark: alpha(orangeBase, 0.7),
      contrastText: '#ffffff',
    },
    secondary: {
      main: grayBase,
      light: alpha(grayBase, 0.5),
      dark: alpha(grayBase, 0.7),
      contrastText: '#ff8400',
    },
  },
});


const MenuPublico = ({ selectedLink }: { selectedLink: number }) => {
  return (
    <div className="main-content-wrapper">
      <ThemeProvider theme={theme}>
        <div className="nav-categories">
          <Button color={selectedLink == 1 ? "primary" : "secondary"} size="large" variant="contained" component={Link} to="/participaciones-federales/montos" className="category-btn">
            <center>Participaciones<br />Federales</center>
          </Button>
          <Button color={selectedLink == 2 ? "primary" : "secondary"} size="large" variant="contained" component={Link} to="/participaciones-estatales/montos" className="category-btn">
            <center>Participaciones<br />Estatales</center>
          </Button>
          <Button color={selectedLink == 3 ? "primary" : "secondary"} size="large" variant="contained" component={Link} to="/aportaciones-federales/montos" className="category-btn">
            <center>Aportaciones<br />Federales</center>
          </Button>
          <Button color={selectedLink == 4 ? "primary" : "secondary"} size="large" variant="contained" component={Link} to="/aportaciones-estatales/montos" className="category-btn">
            <center>Aportaciones<br />Estatales</center>
          </Button>
        </div>
      </ThemeProvider>
    </div>
  );
}

export { MenuPublico };